export default function() {
  const headers = new Headers()
  let authToken = 'none'
  if ('localStorage' in window && window.localStorage !== undefined) {
    authToken = localStorage.getItem('auth_token')
  }

  headers.append('Authorization', `Bearer ${authToken}`)
  headers.append('Content-type', 'application/json')

  return headers
}



// WEBPACK FOOTER //
// ./src/repositories/headers.js